module.exports = __webpack_public_path__ + "media/shipment/LPEXPRESS-8ce4d0b9.svg";